import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const UnAuthorized = () => {
    const navigate = useNavigate();
    const role = Cookies.get("role-elministry") || "";
    const token = Cookies.get("token-elministry");

    const navigateToDashboard = () => {
        let navigationLink = "";
        if (token) {
            switch (role) {
                case "Contributor":
                    navigationLink = "/contributor/dashboard";
                    break;

                case "Teacher":
                    navigationLink = "/teacher/dashboard";
                    break;

                case "Parent":
                    navigationLink = "/parent/dashboard";
                    break;

                case "Learner":
                    navigationLink = "/learner/dashboard";
                    break;
            }
        }
        navigate(navigationLink, { replace: true });
    }

    return (
        <div className="bg-gradient-to-r from-primary to-blue-200 fixed inset-0 z-[10000]">
            <div className="w-9/12 m-auto py-8 sm:py-16 min-h-screen flex items-center justify-center">
                <div className="bg-white shadow overflow-hidden sm:rounded-lg pb-8">
                    <div className="border-t border-gray-200 text-center pt-8">
                        <h1 className="text-5xl sm:text-9xl font-bold text-primary">405</h1>
                        <h1 className="text-2xl sm:text-6xl font-medium px-4 sm:px-12 py-4 sm:py-8">oops! You are not authorized.</h1>
                        <button className="bg-gradient-to-r from-primary to-blue-300 hover:from-blue-700 hover:to-blue-500 text-white font-semibold px-6 py-3 rounded-md mr-6"
                            onClick={() => navigateToDashboard()}>
                            Dashboard
                        </button>
                        <button className="bg-gradient-to-r from-red-400 to-red-500 hover:from-red-500 hover:to-red-500 text-white font-semibold px-6 py-3 rounded-md"
                            onClick={() => navigate("/contact-us", { replace: true })}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnAuthorized